import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Auth from '../../modules/Auth'
import { Link } from 'react-router'

const navigationMenu = [
  {
    route: '/home',
    title: 'Início',
    icon: 'icon-home',
    disable: false
  },
  {
    route: '/gallery',
    defaultRoute: '/gallery/list',
    title: 'Galerias para Entrega',
    icon: 'fo fo-pictures',
    disable: false,
    subroutes: [
      {
        route: '/gallery/list',
        title: 'Minhas Entregas'
      },
      {
        route: '/gallery',
        title: 'Nova Entrega',
        exact: true
      }
    ]
  },
  {
    route: '/collection',
    defaultRoute: '/collection/list',
    title: 'Galerias para Seleção',
    icon: 'fo fo-check-picture',
    subroutes: [
      {
        route: '/collection/list',
        title: 'Minhas Seleções'
      },
      {
        route: '/collection/new',
        title: 'Nova Seleção'
      }
    ]
  },
  {
    route: '/album',
    defaultRoute: '/album/list',
    title: 'Prova de Álbuns',
    icon: 'fo fo-open-book-5',
    subroutes: [
      {
        route: '/album/list',
        title: 'Meus Álbuns'
      },
      {
        route: '/album/new',
        title: 'Novo Álbum'
      }
    ]
  },
  {
    route: '/knowledge',
    defaultRoute: '/knowledge/videos',
    title: 'Área do Conhecimento',
    icon: 'knowledge',
    subroutes: [
      {
        route: '/knowledge/videos',
        title: 'Videos'
      }
    ]
  },
  {
    route: '/settings',
    defaultRoute: '/settings/customize',
    title: 'Configurações',
    icon: 'icon-settings',
    subroutes: [
      {
        route: '/settings/customize',
        title: 'Personalização'
      },
      {
        route: '/settings/watermark',
        title: 'Marca d\'água'
      }
    ]
  }
]

class Sidebar extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      navigationMenu
    }

    this.activeRoute = this.isActive.bind(this)

    // TODO: melhorar método de filtrar menu

    const { subscription } = Auth.userData
    if (!subscription) return
    if (subscription.limits && !subscription.limits.rev) {
      this.state.navigationMenu = navigationMenu.filter((p) => !p.route.includes('/album'))
    }

  }
  isActive(routeName, exact = false) {
    if (exact) {
      return this.props.location.pathname === routeName
    }
    return this.props.location.pathname.startsWith(routeName)
  }
  render() {
    return (
      <div className="page-sidebar-wrapper">
        <div className="page-sidebar navbar-collapse collapse">
          <ul
            className="page-sidebar-menu menu-fixed page-header-fixed page-sidebar-menu-hover-submenu page-sidebar-menu-closed"
            data-keep-expanded="false"
            data-auto-scroll="true"
            data-slide-speed={200}>
            {this.state.navigationMenu.map((mainItem, mainIndex) => mainItem.disable ? null : (
              <li className={'nav-item ' + (this.isActive(mainItem.route) && 'active open')} key={mainIndex}>
                <Link to={mainItem.defaultRoute || mainItem.route} className="nav-link nav-toggle custom-item">
                  <i className={mainItem.icon} style={{ color: !this.isActive(mainItem.route) && "white" }} />
                  <span className="title main">{mainItem.title}</span>
                  {this.isActive(mainItem.route) && <span className="selected" />}
                  <span className="arrow" />
                </Link>
                {
                  !mainItem.subroutes ? null :
                    (
                      <ul className="sub-menu">
                        {mainItem.subroutes.map((subItem, subIndex) => (
                          <li key={`${mainIndex}${subIndex}`} className={'nav-item ' + (this.isActive(subItem.route, subItem.exact) && 'active open')}>
                            <Link to={subItem.route} className="nav-link nav-toggle">
                              <span className="title">{subItem.title}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )
                }
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

Sidebar.propTypes = {
  location: PropTypes.object
}

export default Sidebar
